import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  LayoutDashboard, Building, Users, BookOpen, FileText, TrendingUp,
  Award, Activity, Server, Target, BarChart3, Pencil, Trophy, GripVertical,
  GraduationCap, RefreshCw, Zap, PieChart, HeartPulse, MessageSquare, Mic
} from 'lucide-react';

export const AdminSidebar = ({ user }) => {
  const location = useLocation();
  
  const navItems = [
    { path: '/admin', icon: LayoutDashboard, label: 'Overview', roles: ['super_admin', 'org_admin', 'faculty'] },
    { path: '/admin/growth', icon: TrendingUp, label: 'Growth Analytics', roles: ['super_admin', 'org_admin'] },
    { path: '/admin/exam-dashboard', icon: Award, label: 'Exam Dashboard', roles: ['super_admin', 'org_admin'] },
    { path: '/admin/schools', icon: Building, label: 'Schools', roles: ['super_admin'] },
    { path: '/admin/users', icon: Users, label: 'Users', roles: ['super_admin', 'org_admin'] },
    { path: '/admin/courses', icon: BookOpen, label: 'Courses', roles: ['super_admin', 'faculty'] },
    { path: '/admin/grade-allocation', icon: GraduationCap, label: 'Grade Allocation', roles: ['super_admin'] },
    { path: '/admin/grade-requests', icon: RefreshCw, label: 'Grade Requests', roles: ['super_admin', 'org_admin'] },
    { path: '/admin/lab-analytics', icon: BarChart3, label: 'Lab Analytics', roles: ['super_admin', 'org_admin', 'faculty'] },
    { path: '/admin/course-authoring', icon: Pencil, label: 'Course Authoring', roles: ['super_admin', 'faculty'] },
    { path: '/admin/feature-flags', icon: Zap, label: 'Feature Flags', roles: ['super_admin'] },
    { path: '/admin/question-bank', icon: BookOpen, label: 'Question Bank', roles: ['super_admin'] },
    { path: '/admin/chapter-weightage', icon: PieChart, label: 'Chapter Weightage', roles: ['super_admin'] },
    { path: '/admin/requests', icon: Target, label: 'Requests', roles: ['super_admin', 'org_admin', 'faculty'] },
    { path: '/admin/topic-requests', icon: MessageSquare, label: 'Topic Requests', roles: ['super_admin', 'org_admin', 'faculty'] },
    { path: '/admin/avatar-voices', icon: Mic, label: 'Avatar Voices', roles: ['super_admin'] },
    { path: '/admin/system', icon: Server, label: 'System Panel', roles: ['super_admin'] },
    { path: '/admin/health-check', icon: HeartPulse, label: 'Health Check', roles: ['super_admin'] },
  ];

  const filteredItems = navItems.filter(item => item.roles.includes(user?.role));

  return (
    <div className="w-64 bg-card border-r border-border min-h-screen p-4">
      <div className="mb-6">
        <h2 className="text-lg font-bold flex items-center gap-2">
          <FileText className="w-5 h-5" />
          Admin Panel
        </h2>
      </div>
      <nav className="space-y-1">
        {filteredItems.map((item) => {
          const isActive = location.pathname === item.path;
          return (
            <Link
              key={item.path}
              to={item.path}
              className={`nav-item ${isActive ? 'nav-item-active' : ''}`}
            >
              <item.icon className="w-5 h-5" />
              {item.label}
            </Link>
          );
        })}
      </nav>
    </div>
  );
};

